// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"636":"ac9f16b1","909":"359f11b4","934":"7dedc753"}[chunkId] + ".chunk.js";
};